import { render, staticRenderFns } from "./AccountReset.vue?vue&type=template&id=4bbc97a6"
import script from "./AccountReset.vue?vue&type=script&lang=js"
export * from "./AccountReset.vue?vue&type=script&lang=js"
import style0 from "./AccountReset.vue?vue&type=style&index=0&id=4bbc97a6&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports